export default __webpack_public_path__ + "static/media/spinner-white.8e06ab13.svg";